module.exports = __webpack_public_path__ + "static/img/zrc-sazu.3ee27da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters/zrc-sazu.jpg
// module id = GQI/
// module chunks = 1